// Pro plan price IDs
export const PRO_PLAN_PRICE_IDS = [
  'price_1QiFoKL6hyI2wddeDrG84QMO',
  'price_1QtUk0L6hyI2wddeQJ9XjdRl',
  'price_1QtUjgL6hyI2wdde1QqUJoG1',
  'price_1N2zDbL6hyI2wddeW4ebJgeu',
  'price_1Mw8aQL6hyI2wddeprlHTFMX',
  'price_1RjdvQL6hyI2wddePM5dionX', // pro yearly discounted (69.99)
  'price_1Rji1NL6hyI2wddelQjL83zb', // High income monthly
  'price_1Rji2dL6hyI2wddemysD04dK', // High income yearly
  'price_1QiFoCL6hyI2wddetuUDAA8b' // Test price ID
];

// Helper function to check if a price ID belongs to a pro plan
export const isProPlan = (priceId) => PRO_PLAN_PRICE_IDS.includes(priceId);

// Helper function to check if user has a paid plan (active or trialing)
export const hasPaidPlan = (user) => {
  const subscription = user?.subscriptions?.raw_subscriptions?.[0];
  if (!subscription) return false;
  
  const status = subscription.status;
  return status === 'active' || status === 'trialing';
};

// Helper function to check if user is on a pro plan and has a paid plan
export const isPaidProUser = (user) => {
  if (!hasPaidPlan(user)) return false;
  
  const planId = user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
  return planId ? isProPlan(planId) : false;
}; 